import { render, staticRenderFns } from "./ContentAppHeaderLabel.vue?vue&type=template&id=209b7322&"
import script from "./ContentAppHeaderLabel.vue?vue&type=script&lang=ts&"
export * from "./ContentAppHeaderLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports